import { EboNameObjectTO } from '../base-classes/ebo-name-object-to';
import { Division } from '../division/division';
import { Employee } from '../employee/employee';
import { EboRoles, EboRolesMapping } from '../shared/policies/ebo-roles.enum';
import { UserExperience } from '../shared/user-experience';

export class ETaskAssignee extends EboNameObjectTO {
  eTaskId: string;
  //Who Can Approve
  employeeID: string;
  employee: Employee;
  role: EboRoles;
  divisionId: string;
  division: Division;

  constructor(jsonData?: Partial<ETaskAssignee>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.employee) {
        this.employee = new Employee(jsonData.employee);
      }
      if (jsonData.division) {
        this.division = new Division(jsonData.division);
      }
    }
  }

  isApprover(ux: UserExperience): boolean {
    if (this.employeeID) {
      return this.employeeID === ux.activeEmployeeID;
    }
    if (this.role) {
      if (ux.activeEmployee?.isCorporate()) return ux.activeEmployee.hasRoleOrBetter(this.role);
      if (this.divisionId && !ux.managedDivisionIds.includes(this.divisionId)) return false;
      return ux.activeEmployee.hasRoleOrBetter(this.role);
    }
    return false;
  }

  toSummaryText(): string {
    //console.log('ETaskAssignee.toSummaryText', this);
    if (this.employeeID) return this.employee?.toShortString() + 'Unknown';
    if (this.divisionId) return `${this.division?.name ?? 'Unknown'}: ${EboRolesMapping[this.role]}`;
    return EboRolesMapping[this.role];
  }
}
